export const NAV_ITEM_WIDTH = 75;
export const MOBILE_NAV_PADDING = 42;
export const MORE_BUTTON_WIDTH = NAV_ITEM_WIDTH;
